import api,{videoApi} from './http-common';
import { format, parse } from 'date-fns';
import { SERVER } from '../common/const/networkUrls';
import { IsUnauthorized } from '../common/utility/utility';


export async function fetchDailyRevenueDetailsApi(bpCode, revenueDate,startDate, endDate, isWeekly) {
    try {
        let path=null;
        if(isWeekly){
            startDate=format(parse(startDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy" )
            endDate=format(parse(endDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy" )
            path=api.get(`${SERVER.SERVICES.getWeeklyRevenueDetails}?businessPartnerCode=${bpCode}&revenueStartDate=${startDate}&revenueEndDate=${endDate}`);
        }else{
            revenueDate = format(parse(revenueDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy" )
            path=api.get(`${SERVER.SERVICES.getRevenueDetails}?businessPartnerCode=${bpCode}&revenueDate=${revenueDate}`);
        }
         
         const response =  await path;
         const body = await response;
         return body.data;

    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}

export async function submitDailyRevenueDetailsApi(revenueData, revenueDate, submittedBy, isChangeRequest, isWeekly) {
    try {
        let dailyRevenueRequest = {
            businessPartnerCode: revenueData.businessPartnerCode,
            revenueDate: format(parse(isWeekly ? revenueData.revenueDate : revenueDate, "dd/MM/yyyy", new Date()), "MM/dd/yyyy"),
            contractCode: revenueData.contractCode,
            soldTickets: null,
            isShopOpen: null,
            remarksId: null,
            CreatedBy: submittedBy,
            RevenueWithTaxAmount: null,
            RevenueWithoutTaxAmount: null,
            revenueId: 0,
            businessPartnerRemarks: null
        }

        let tax_0 = Number((revenueData.revenueAmount.tax_0.replace(/\./g, "")).replace(/\,/g, "."));
        let tax_6 = Number((revenueData.revenueAmount.tax_6.replace(/\./g, "")).replace(/\,/g, "."));
        let tax_12 = Number((revenueData.revenueAmount.tax_12.replace(/\./g, "")).replace(/\,/g, "."));
        let tax_21 = Number((revenueData.revenueAmount.tax_21.replace(/\./g, "")).replace(/\,/g, "."));
        let soldTicket = Number(revenueData.soldTicket.replace(/\./g, ""));
        let isShopOpen = revenueData.isShopOpen === "Yes" ? true : false;
        let remarksId = revenueData.remarksId;

        if (isChangeRequest) {
            const changeRequestData = revenueData.isChangeRequestAllowed && revenueData.changeRequest;
            if (changeRequestData) {
                const cr_tax_0 = Number((changeRequestData.revenueAmount.tax_0.replace(/\./g, "")).replace(/\,/g, "."));
                const cr_tax_6 = Number((changeRequestData.revenueAmount.tax_6.replace(/\./g, "")).replace(/\,/g, "."));
                const cr_tax_12 = Number((changeRequestData.revenueAmount.tax_12.replace(/\./g, "")).replace(/\,/g, "."));
                const cr_tax_21 = Number((changeRequestData.revenueAmount.tax_21.replace(/\./g, "")).replace(/\,/g, "."));
                const cr_soldTicket = Number(changeRequestData.soldTicket.replace(/\./g, ""));
                const cr_isShopOpen = changeRequestData.isShopOpen === "Yes" ? true : false;
                const cr_remarksId = changeRequestData.remarksId;

                if (isShopOpen === cr_isShopOpen) { isShopOpen = null }
                if (remarksId === cr_remarksId) { remarksId = null }
                if (soldTicket === cr_soldTicket) { soldTicket = null }
                if (tax_0 === cr_tax_0) { tax_0 = null }
                if (tax_6 === cr_tax_6) { tax_6 = null }
                if (tax_12 === cr_tax_12) { tax_12 = null }
                if (tax_21 === cr_tax_21) { tax_21 = null }

                dailyRevenueRequest.revenueId = revenueData.revenueId;
                dailyRevenueRequest.businessPartnerRemarks = changeRequestData.businessPartnerRemarks;
            }
        }

        const revenueAmountWithVat = (isChangeRequest && tax_0 === null && tax_6 === null
            && tax_12 === null && tax_21 === null) ? null : {
                "tax_0": tax_0,
                "tax_6": tax_6,
                "tax_12": tax_12,
                "tax_21": tax_21
            }

        const revenueAmountWithoutVat = isChangeRequest ? !revenueAmountWithVat ? null : {
            "tax_0": tax_0 === null ? null : ((tax_0 * 100) / (100 + 0)),
            "tax_6": tax_6 === null ? null : ((tax_6 * 100) / (100 + 6)),
            "tax_12": tax_12 === null ? null : ((tax_12 * 100) / (100 + 12)),
            "tax_21": tax_21 === null ? null : ((tax_21 * 100) / (100 + 21))
        } : {
                "tax_0": ((tax_0 * 100) / (100 + 0)),
                "tax_6": ((tax_6 * 100) / (100 + 6)),
                "tax_12": ((tax_12 * 100) / (100 + 12)),
                "tax_21": ((tax_21 * 100) / (100 + 21))
            }

        dailyRevenueRequest = {
            ...dailyRevenueRequest,
            soldTickets: soldTicket,
            isShopOpen: isShopOpen,
            remarksId: remarksId,
            RevenueWithTaxAmount: revenueAmountWithVat,
            RevenueWithoutTaxAmount: revenueAmountWithoutVat,
        }

        const response = await api.post(`${!isChangeRequest ? SERVER.SERVICES.submitRevenueDetails : SERVER.SERVICES.submitChangeRequest}`, dailyRevenueRequest);

        const body = await response;

        return body.data;
    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}

export async function fetchStatuswiseRevenueDatesApi(minDate, maxDate, bpCode) {
    try {
        minDate = format(parse(minDate, "dd/MM/yyyy", new Date()), "MM/dd/yyyy");
        maxDate = format(parse(maxDate, "dd/MM/yyyy", new Date()), "MM/dd/yyyy");
        const response = await api.get(`${SERVER.SERVICES.getStatuswiseRevenueDates}?businessPartnerCode=${bpCode}&revenueStartDate=${minDate}&revenueEndDate=${maxDate}`);
        const body = await response;
        return body.data;
    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}

export async function fetchMonthlyIntakeBookDetailsApi(bpCode, intakeBookDate) {
    try {
        const response =  await api.get(`${SERVER.SERVICES.getMonthlyIntakeBookDetails}?businessPartnerCode=${bpCode}&intakeBookDate=${intakeBookDate}`);  
        const body = await response;
        return body.data;
    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}

export async function submitMonthlyIntakeBookDetailsApi(intakeBookRequestData) {
    try {
        const response = await api.post(`${SERVER.SERVICES.getMonthlyIntakeBookDetails}`, intakeBookRequestData);
        const body = await response;
        return body.data;
    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}

export async function submitSelectedDailyRevenueDetailsApi(selectedUnsubmittedRevenues, revenueDate, submittedBy, isWeekly) {
    try {
        let selectedContractsRevenueDetails = [];

        selectedUnsubmittedRevenues.map(data => {
            let revenueInputData = {
                businessPartnerCode: data.businessPartnerCode,
                revenueDate: format(parse(isWeekly ? data.revenueDate : revenueDate, "dd/MM/yyyy", new Date()), "MM/dd/yyyy"),
                contractCode: data.contractCode,
                soldTickets: null,
                isShopOpen: null,
                remarksId: null,
                CreatedBy: submittedBy,
                RevenueWithTaxAmount: null,
                RevenueWithoutTaxAmount: null,
                revenueId: 0,
                businessPartnerRemarks: null
            }

            let tax_0 = Number((data.revenueAmount.tax_0.replace(/\./g, "")).replace(/\,/g, "."));
            let tax_6 = Number((data.revenueAmount.tax_6.replace(/\./g, "")).replace(/\,/g, "."));
            let tax_12 = Number((data.revenueAmount.tax_12.replace(/\./g, "")).replace(/\,/g, "."));
            let tax_21 = Number((data.revenueAmount.tax_21.replace(/\./g, "")).replace(/\,/g, "."));
            let soldTicket = Number(data.soldTicket.replace(/\./g, ""));
            let isShopOpen = data.isShopOpen === "Yes" ? true : false;
            let remarksId = data.remarksId;

            const revenueAmountWithVat = {
                "tax_0": tax_0,
                "tax_6": tax_6,
                "tax_12": tax_12,
                "tax_21": tax_21
            }

            const revenueAmountWithoutVat = {
                "tax_0": ((tax_0 * 100) / (100 + 0)),
                "tax_6": ((tax_6 * 100) / (100 + 6)),
                "tax_12": ((tax_12 * 100) / (100 + 12)),
                "tax_21": ((tax_21 * 100) / (100 + 21))
            }

            revenueInputData = {
                ...revenueInputData,
                soldTickets: soldTicket,
                isShopOpen: isShopOpen,
                remarksId: remarksId,
                RevenueWithTaxAmount: revenueAmountWithVat,
                RevenueWithoutTaxAmount: revenueAmountWithoutVat,
            }

            selectedContractsRevenueDetails.push(revenueInputData);
        });

        if (selectedContractsRevenueDetails && selectedContractsRevenueDetails.length > 0) {
            const response = await api.post(`${SERVER.SERVICES.submitSelectedRevenueDetails}`, selectedContractsRevenueDetails);

            const body = await response;

            return body.data;
        }
    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}

export async function submitSelectedDailyIntakeDetailsApi(intakeBookRequestData) {
    try {
        const response = await api.post(`${SERVER.SERVICES.submitSelectedDailyIntakeDetails}`, intakeBookRequestData);
        const body = await response;
        return body.data;
    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}

export async function submitUnblockContractRequestApi(unblockRequestData) {
    try {
        const response =  await api.post(`${SERVER.SERVICES.submitUnblockRequest}`, unblockRequestData);         
        const body = await response;
        return body.data;

    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}


export async function unblockContractStatusApi(bpCode) {
    try {
        const response = await api.get(`${SERVER.SERVICES.getUnblockCrStatus}?businessPartnerCode=${bpCode}`);
        const body = await response;
        return body.data;


    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}

export async function getHelpVideoUrlApi(bpCode,langugeCode,config={}) {
    try {
        const response = await videoApi.get(`${SERVER.SERVICES.getHelpVideoUrl}?businessPartnerCode=${bpCode}&langugeCode=${langugeCode}`, config);
        return response;
    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}

export async function elearningSubmit(bpcode,userId) {
    try{
       const response =  await api.post(`${SERVER.SERVICES.UserELearningSubmit}?businessPartnerCode=${bpcode}&UserId=${userId}`);  
       const body =  response;
       return body.data;
    }
    catch (error) {
        IsUnauthorized(error);
        return error;
    }
}